import { render, staticRenderFns } from "./CreateBenchmarkButton.vue?vue&type=template&id=56015ea8&"
import script from "./CreateBenchmarkButton.vue?vue&type=script&lang=js&"
export * from "./CreateBenchmarkButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports